import React from "react";

import withStyles from "@material-ui/styles/withStyles";

import {
  Create,
  Edit,
  Show,
  List,
  Filter,
  SimpleForm,
  SimpleShowLayout,
  ReferenceInput,
  SelectInput,
  SelectArrayInput,
  ReferenceField,
  TextInput,
  TextField,
  required,
  Datagrid,
  ShowButton,
  EditButton,
  BackButton,
  PageFooter,
  FilterButton,
  CreateButton,
} from "jazasoft";
import { Role } from "../utils/types";

const choicesScope = [
  { id: "read", name: "Read" },
  { id: "write", name: "Write" },
  { id: "update", name: "Update" },
  { id: "delete", name: "Delete" },
];

const FormFooter = ({ roles, ...props }) => (
  <PageFooter>
    {roles && roles.includes(Role.MASTER) && <EditButton variant="contained" color="primary" style={{ marginRight: "0.5em" }} {...props} />}
    <BackButton variant="contained" color="default" />
  </PageFooter>
);

const inputOptions = (sm) => ({
  xs: 12,
  sm,
  fullWidth: true,
  options: { fullWidth: true },
});

const createStyle = (theme) => ({});

export const CreateResource = withStyles(createStyle)(({ classes, ...props }) => {
  return (
    <Create
      parse={({ scopes, ...rest }) => ({
        ...rest,
        scopes: scopes.join(","),
      })}
      {...props}
    >
      <SimpleForm className={classes.form} redirect="home">
        <ReferenceInput source="appId" reference="apps" validate={[required()]} {...inputOptions(3)}>
          <SelectInput />
        </ReferenceInput>
        <TextInput source="name" validate={[required()]} {...inputOptions(3)} />
        <TextInput label="Resource Id" source="resourceId" validate={[required()]} {...inputOptions(3)} />
        <SelectArrayInput source="scopes" validate={[required()]} choices={choicesScope} {...inputOptions(3)} />
        <TextInput label="Operations" source="actions" {...inputOptions(3)} />
        <TextInput source="desc" {...inputOptions(3)} />
      </SimpleForm>
    </Create>
  );
});

const editStyle = (theme) => ({});

export const EditResource = withStyles(editStyle)(({ classes, ...props }) => {
  return (
    <Edit
      format={(record = {}) => ({
        ...record,
        scopes: record.scopes && record.scopes.split(","),
      })}
      parse={({ scopes, ...rest }) => ({ ...rest, scopes: scopes.join(",") })}
      {...props}
    >
      <SimpleForm className={classes.form} redirect="home">
        <ReferenceInput source="appId" reference="apps" validate={[required()]} {...inputOptions(3)}>
          <SelectInput />
        </ReferenceInput>
        <TextInput source="name" validate={[required()]} {...inputOptions(3)} />
        <TextInput label="Resource Id" source="resourceId" validate={[required()]} {...inputOptions(3)} />
        <SelectArrayInput source="scopes" validate={[required()]} choices={choicesScope} {...inputOptions(3)} />
        <TextInput label="Operations" source="actions" {...inputOptions(3)} />
        <TextInput source="desc" {...inputOptions(3)} />
      </SimpleForm>
    </Edit>
  );
});

const fieldOptions = {
  xs: 12,
  sm: 4,
};

const viewStyle = (theme) => ({
  padding: {
    padding: "1.5em",
  },
});

export const ViewResource = withStyles(viewStyle)(({ classes, ...props }) => {
  const roles = props.roles || [];

  return (
    <Show {...props}>
      <SimpleShowLayout footer={<FormFooter roles={roles} />} className={classes.padding}>
        <TextField source="name" {...fieldOptions} />
        <TextField source="resourceId" {...fieldOptions} />
        <ReferenceField source="appId" reference="apps">
          <TextField source="name" {...fieldOptions} />
        </ReferenceField>
        <TextField source="scopes" {...fieldOptions} />
        <TextField source="actions" {...fieldOptions} />
        <TextField source="desc" {...fieldOptions} />
      </SimpleShowLayout>
    </Show>
  );
});

const filters = (
  <Filter>
    <ReferenceInput
      label="App"
      resource="apps"
      source="appId"
      reference="apps"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      xs={12}
      fullWidth
      options={{ fullWidth: true }}
    >
      <SelectInput />
    </ReferenceInput>
  </Filter>
);

const homeStyle = (theme) => ({
  buttonEdit: {
    width: theme.spacing(14),
  },
  buttonDelete: {
    width: theme.spacing(16),
  },
});

export const ResourceHome = withStyles(homeStyle)(({ classes, ...props }) => {
  const roles = props.roles || [];
  return (
    <List
      searchKeys={["name", "resourceId"]}
      filters={roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) ? filters : null}
      actions={({ basePath, resource }) => (
        <div>
          {roles.includes(Role.MASTER) && <CreateButton basePath={basePath} showLabel={false} />}
          {(roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER)) && <FilterButton showLabel={false} resource={resource} />}
        </div>
      )}
      parse={({ appId }) => ({
        "app.id": appId,
      })}
      {...props}
    >
      <Datagrid>
        <TextField source="name" />
        <TextField source="resourceId" />
        {(roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER)) && (
          <ReferenceField source="appId" reference="apps">
            <TextField source="name" />
          </ReferenceField>
        )}
        <ShowButton cellClassName={classes.buttonEdit} />
        {roles.includes(Role.MASTER) && <EditButton cellClassName={classes.buttonEdit} />}
      </Datagrid>
    </List>
  );
});
